import { render, staticRenderFns } from "./captureCustomer.vue?vue&type=template&id=f4325d62"
import script from "./captureCustomer.ts?vue&type=script&lang=js&external"
export * from "./captureCustomer.ts?vue&type=script&lang=js&external"
import style0 from "./captureCustomer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports